import { ResourceLanguage } from "i18next";
import mapKeys from "lodash/mapKeys";
import mapValues from "lodash/mapValues";

export enum LanguageResourceKey {
  en = "en",
  frCA = "fr-CA",
  frFR = "fr-FR",
  esES = "es-ES",
  noNO = "no-NO",
  ptPT = "pt-PT",
  svSE = "sv-SE",
  deDE = "de-DE",
  fiFI = "fi-FI",
  daDK = "da-DK",
  jaJP = "ja-JP"
}

const getFileName = (path: string) =>
  path
    .split("/")
    .pop()
    ?.replace(/\.[^/.]+$/, "");

// Build a namespace map from a Vite eager-glob result.
const toNamespaceMap = (glob: Record<string, unknown>): ResourceLanguage =>
  mapValues(
    mapKeys(glob, (_, path) => getFileName(path)),
    (mod) => (mod as { default: ResourceLanguage }).default
  ) as ResourceLanguage;

const en = toNamespaceMap(import.meta.glob("../../../../config/i18n/en/*.json", { eager: true }));

const frCA = toNamespaceMap(import.meta.glob("../../../../config/i18n/frCA/*.json", { eager: true }));

const frFR = toNamespaceMap(import.meta.glob("../../../../config/i18n/frFR/*.json", { eager: true }));

const esES = toNamespaceMap(import.meta.glob("../../../../config/i18n/esES/*.json", { eager: true }));

const noNO = toNamespaceMap(import.meta.glob("../../../../config/i18n/noNO/*.json", { eager: true }));

const ptPT = toNamespaceMap(import.meta.glob("../../../../config/i18n/ptPT/*.json", { eager: true }));

const svSE = toNamespaceMap(import.meta.glob("../../../../config/i18n/svSE/*.json", { eager: true }));

const deDE = toNamespaceMap(import.meta.glob("../../../../config/i18n/deDE/*.json", { eager: true }));

const fiFI = toNamespaceMap(import.meta.glob("../../../../config/i18n/fiFI/*.json", { eager: true }));

const daDK = toNamespaceMap(import.meta.glob("../../../../config/i18n/daDK/*.json", { eager: true }));

const jaJP = toNamespaceMap(import.meta.glob("../../../../config/i18n/jaJP/*.json", { eager: true }));

export const resources = {
  [LanguageResourceKey.en]: en,
  [LanguageResourceKey.frCA]: frCA,
  [LanguageResourceKey.frFR]: frFR,
  [LanguageResourceKey.esES]: esES,
  [LanguageResourceKey.noNO]: noNO,
  [LanguageResourceKey.ptPT]: ptPT,
  [LanguageResourceKey.svSE]: svSE,
  [LanguageResourceKey.deDE]: deDE,
  [LanguageResourceKey.fiFI]: fiFI,
  [LanguageResourceKey.daDK]: daDK,
  [LanguageResourceKey.jaJP]: jaJP
};
